// import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
// import ReactPlayer from 'react-player'
import "./BusinessHero.scss";

export default function BusinessHero({ heroObj }) {
  const router = useNavigate();

  return (
    <section className="">
      <div className="position-relative overflow-hidden">
        <div
          className="d-md-flex d-none hero_video"
          style={{ backgroundImage: `url(${heroObj.img})` }}
        >
          <video
            autoPlay
            poster={heroObj.img}
            muted
            loop
            playsInline
            width="100%"
            className=""
          >
            <source src={heroObj?.video} type="video/webm"></source>
          </video>
        </div>
        <div
          className="d-md-none hero_mobile"
          style={{ backgroundImage: `url(${heroObj.imgM})` }}
        >
          <video
            autoPlay
            muted
            loop
            playsInline
            poster={heroObj.imgM}
            width="100%"
            className=""
          >
            <source src={heroObj?.videoM} type="video/webm"></source>
          </video>
        </div>
        <div className="top_banner ne_ul position-absolute col-lg-8 text-start ">
          <div className="container">
            <div data-aos="fade-down" className="mb-4">
              <h1 className="text-white">{heroObj?.title}</h1>
              <h2 className="text-white">{heroObj?.subTitle}</h2>
              <p className="text-white four_line"> {heroObj?.desc}</p>
            </div>
            <div className="d-flex flex-wrap justify-content-start gap-2 mb-5 mt-4">
              <button
                className="btn btn-wl"
                onClick={() => router("/get-started")}
                type="button"
              >
                {heroObj?.btn1}
              </button>
              <button
                className="btn btn-wl2"
                onClick={() => router("/get-started")}
                type="button"
              >
                {heroObj?.btn2}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

BusinessHero.propTypes = {
  heroObj: PropTypes.object,
};
